import { clsx } from 'clsx'
import { fixImageUrl } from 'component/Image/util'
import { useLatestCallback } from 'hook/useLatestCallback'
import { CSSProperties, SyntheticEvent } from 'react'
import css from './Img.module.scss'

type Props = {
  className?: string
  fit?: boolean
  cover?: boolean
  src?: string
  style?: CSSProperties
  height?: number
  onLoad?(event: SyntheticEvent<HTMLImageElement>): void
  onError?(event: SyntheticEvent<HTMLImageElement>): void
  onRef?(element: HTMLImageElement | null): void
}

export const Img = (props: Props) => {
  const { fit, cover, style, height, onLoad, onError } = props
  const src = fixImageUrl(props.src ?? '')
  const className = clsx(props.className, !src && css.none, fit && css.fit, cover && css.cover)

  const onRef = useLatestCallback((element: HTMLImageElement | null) => {
    if (props.onRef) props.onRef(element)
  })

  return <img ref={onRef} className={className} style={style} src={src} alt=""
    height={height} onLoad={onLoad} onError={onError} />
}
